/**
 * created by lei lei on 2021/3/11
 * 系统日志
 */
import request from "../base/request";
import {applicationName} from "../utils";

let host="/cm-sites-" + applicationName()+'/';
const Apis = {
    getList: host + 'log/getList',//获取系统日志列表
    getAllLogBackup: host + '/logBackup/getAllLogBackup',//获取每日日志
};

export const getList = (body, callBack) => {
    request({url:Apis.getList, body, callBack});
};


//获取每日数据
export const getAllLogBackup = (body,callBack) => {
    request({url:Apis.getAllLogBackup, body, callBack});
};



